export default function (num) {
  if (num > 999999) {
    return 'font_20'
  } else if (num > 99999) {
    return 'font_24'
  } else {
    return 'font_28'
  }
}
